export enum UserRolesEnum {
    SuperAdmin = "Super Admin",
    Admin = "Admin",
    ResultManager = "Result Manager",
    DealershipManager = "Dealership Manager",
    DealershipEmployee = "Dealership Employee",
}